import Axios from "../config/config";


export const LEARNER_LIST = async (body) => {
    try {
        const response = await Axios.post('learner-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};





export const EDIT_LEARNER = async (body) => {
    try {
        const response = await Axios.post('edit-learner/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_LEARNER = async (body) => {
    try {
        const response = await Axios.post('view-learner/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const CHANGE_LEARNER_PASSWORD = async (body) => {
    try {
        const response = await Axios.post('change-learner-password/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LEARNER_STATUS = async (body) => {
    try {
        const response = await Axios.post('learner-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const BULD_ADD_LEARNER_TEMPLATE = async (body) => {
  try {
    const response = await Axios.post( 'bulk-add-learner-template/',body,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const ADD_LEARNER = async (body, token) => {
    try {
        const response = await Axios.post("add-learner/", body, {
            headers: {
                "Content-Type": "multipart/form-data", // 
            },
        });
        return response;
    } catch (error) {
        console.error("ADD_LEARNER ERROR:", error?.response?.data || error.message);
        throw error;
    }
};


export const BULD_ADD_LEARNERS = async (body) => {
    try {
        const response = await Axios.post('bulk-add-learner/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULK_OILINDIA_LEARNER = async (body) => {
    try {
        const response = await Axios.post('bulk-oilindia-learner/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_LEARNER_ALL_COURSES = async (body) => {
    try {
        const response = await Axios.post('list-learner-all-courses/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LEANER_WATCHTIME= async (body) => {
    try {
        const response = await Axios.post('learner-watchtime-summary/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
